import React from "react";
import { Stack } from "@mui/material";
import Icon from "src/components/icon";
import githubIcon from "src/assets/icons/github-int";
import gitlabIcon from "src/assets/icons/gitlab-int";
import googleWorkspaceIcon from "src/assets/icons/google-workspace-int";
import slackIcon from "src/assets/icons/slack-int";
import jiraIcon from "src/assets/icons/jira-int";
import notionIcon from "src/assets/icons/notion-int";
import styled from "styled-components";

const InfoText = styled.p`
    margin: 0;
    font-size: 12px;
    font-weight: 200;
`;

const calculateFill = (isFulfilled) => {
    if (isFulfilled === true) return "palette.primary.main";
    return "palette.secondary.main";
};

const calculateDependencies = (dependencies) => {
    if (!dependencies) return null;
    return dependencies.map((dependency) => {
        if (dependency.name === "git") {
            return (
                <Stack direction="row" spacing={1} key={dependency.name} m={0.5}>
                    <Icon svg={githubIcon} fill={calculateFill(dependency.fulfilled)} />
                    <Icon svg={gitlabIcon} fill={calculateFill(dependency.fulfilled)} />
                    <InfoText>{dependency.impact}</InfoText>
                </Stack>
            );
        }
        if (dependency.name === "calendar" || dependency.name === "calendar-centrally-managed") {
            return (
                <Stack direction="row" spacing={1} key={dependency.name} m={0.5}>
                    <Icon svg={googleWorkspaceIcon} fill={calculateFill(dependency.fulfilled)} />
                    <InfoText>{dependency.impact}</InfoText>
                </Stack>
            );
        }
        if (dependency.name === "slack") {
            return (
                <Stack direction="row" spacing={1} key={dependency.name} m={0.5}>
                    <Icon svg={slackIcon} fill={calculateFill(dependency.fulfilled)} />
                    <InfoText>{dependency.impact}</InfoText>
                </Stack>
            );
        }
        if (dependency.name === "pm") {
            return (
                <Stack direction="row" spacing={1} key={dependency.name} m={0.5}>
                    <Icon svg={jiraIcon} fill={calculateFill(dependency.fulfilled)} />
                    <Icon svg={notionIcon} fill={calculateFill(dependency.fulfilled)} />
                    <InfoText>{dependency.impact}</InfoText>
                </Stack>
            );
        }
        if (dependency.name === "enable") {
            return (
                <Stack direction="row" spacing={1} key={dependency.name} m={0.5}>
                    <InfoText>This feature needs to be enabled</InfoText>
                </Stack>
            );
        }
        return null;
    });
};

export default calculateDependencies;
